var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// tslint:disable:max-line-length
// This file is generated by generateStyles script.
// Please don't edit it manually.
import * as React from "react";
import "../../less/svg/SortBtn.less";
export var SortBtn = function (props) { return (React.createElement("svg", { viewBox: "0 0 25 30" },
    React.createElement("defs", null),
    React.createElement("g", __assign({ id: "Layer_2" }, props, { className: "SortBtn " + props.className }),
        React.createElement("g", { id: "Buttons" },
            React.createElement("g", { id: "SortBtnN_container", "data-name": "SortBtnN#container" },
                React.createElement("rect", { className: "cls-1", y: 3, width: 25, height: 27, rx: 10 }),
                React.createElement("g", { id: "NormalHudBtn_container", "data-name": "NormalHudBtn#container" },
                    React.createElement("rect", { className: "cls-2", x: 0.75, y: 0.75, width: 23.5, height: 25.5, rx: 9.25 }),
                    React.createElement("path", { className: "cls-3", d: "M15 1.5a8.51 8.51 0 0 1 8.5 8.5v7a8.51 8.51 0 0 1-8.5 8.5h-5A8.51 8.51 0 0 1 1.5 17v-7A8.51 8.51 0 0 1 10 1.5h5M15 0h-5A10 10 0 0 0 0 10v7a10 10 0 0 0 10 10h5a10 10 0 0 0 10-10v-7A10 10 0 0 0 15 0z" })),
                React.createElement("path", { className: "cls-4", d: "M15 22.5h-5A8.51 8.51 0 0 1 1.5 14v3a8.51 8.51 0 0 0 8.5 8.5h5a8.51 8.51 0 0 0 8.5-8.5v-3a8.51 8.51 0 0 1-8.5 8.5z" }),
                React.createElement("path", { className: "cls-5", d: "M12.5 9.5H19l-3.25 4-3.25 4-3.25-4L6 9.5h6.5z" })))))); };



//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/SortBtn.tsx
// module id = 2611
// module chunks = 3